import { render } from "./PasswordRecoveryPage.vue?vue&type=template&id=6fd4e3e7&scoped=true"
import script from "./PasswordRecoveryPage.vue?vue&type=script&lang=ts"
export * from "./PasswordRecoveryPage.vue?vue&type=script&lang=ts"

import "./PasswordRecoveryPage.vue?vue&type=style&index=0&id=6fd4e3e7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fd4e3e7"

export default script